import { j as o } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { Alert as n } from "@mui/joy";
import { memo as a } from "react";
import { S as t } from "../../../../../../index.BRz-o-Vs.js";
const r = a(({
  syncDirection: e
}) => /* @__PURE__ */ o.jsx(n, { children: e === t.IMPORT ? null : e === t.EXPORT ? "This will export the selected dataset as an Audience Segment in Google Ad Manager 360. The dataset should have only one column with the list of identifiers. The type of identifier and the segment can be specified in the next screen. Note: Please access your Google Ad Manager 360 account to verify the created audience segment." : null }));
r.displayName = "TradeDeskInfo";
export {
  r as default
};
//# sourceMappingURL=GoogleAdManagerInfo.js.map
